import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { TimeConstrainedBaseQueryModel } from 'humanresources-common-shared';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrPerObjectDefinitionQueryModel')
export class PerObjectDefinitionQueryModel extends TimeConstrainedBaseQueryModel {
    @EmptyControl()
    @JsonProperty('id', Number, true)
    id?: number = null;

    @EmptyControl()
    @JsonProperty('perObjectId', Number, true)
    perObjectId?: number = null;

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber?: string = null;

    @EmptyControl()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId?: number = null;

    @EmptyControl()
    @JsonProperty('objectStatusCode', String, true)
    objectStatusCode?: string = null;

    @JsonProperty('objectStatusCodeList', [String], true)
    objectStatusCodeList?: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('genCountryId', Number, true)
    genCountryId: number = null;

    @EmptyControl()
    @JsonProperty('text', String, true)
    text?: string = null;

    @EmptyControl()
    @JsonProperty('perObjectCode', String, true)
    perObjectCode?: string = null;

    @EmptyControl()
    @JsonProperty('objectTypeCode', String, true)
    objectTypeCode?: string = null;

    @EmptyControl()
    @JsonProperty('objectTypeCodes', [String], true)
    objectTypeCodes?: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('longText', String, true)
    longText?: string = null;

    @EmptyControl()
    @JsonProperty('commonSearchText', String, true)
    commonSearchText?: string = null;

    @EmptyControl()
    @JsonProperty('searchTextHistoricalMatchDate', HvlDateConverter, true)
    searchTextHistoricalMatchDate?: Date = null;

    @JsonProperty('timeConstraintsControl', Boolean, true)
    timeConstraintsControl?: boolean = true;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active?: boolean = true;

    @EmptyControl()
    @JsonProperty('activateHrAuthCheck', Boolean, true)
    activateHrAuthCheck?: boolean = true;

    @EmptyControl()
    @JsonProperty('idList', [Number], true)
    idList: Array<number> = new Array<number>();
}
